import { call, put } from "redux-saga/effects";
import { takeEvery } from "redux-saga/effects";

import {
  GET_SERVICE_RESOURCE_AVAILABILITY_DATES,
  GOT_SERVICE_RESOURCE_AVAILABILITY_DATES,
  SAVE_WAITLIST,
  SAVE_WAITLIST_ERROR,
  SAVED_WAITLIST
} from "../waitlist";
import { getLocalStorageItem, getSpId, getLocationId } from "../../utils/helpers";
import { UPDATED_GLOBAL_SUCCESS_MESSAGE } from "../globalSuccess";
import { handleApiErrors, IsvalidId } from "./helpers";

/***** SAGA START ******/

export let getServiceResourceAvailabilityApi = payload => {
  let { serviceId, resourceId, day } = payload.data;

  if (IsvalidId(getSpId()) && IsvalidId(getLocationId()) && IsvalidId(serviceId) && IsvalidId(resourceId)) {
    let URL = "";

    if (day) {
      URL = `${
        window.APP.apiPath
      }api/serviceprovider/${getSpId()}/availability/alltimeslots?svcrsc1=${serviceId},${resourceId}&day=${day}&locationid=${getLocationId()}`;
    } else {
      URL = `${
        window.APP.apiPath
      }api/serviceprovider/${getSpId()}/availability?svcrsc1=${serviceId},${resourceId}&locationid=${getLocationId()}`;
    }
    return fetch(URL, {
      headers: { Authorization: getLocalStorageItem("token_authorization") }
    })
      .then(response => {
        return response.json().then(result => {
          if (result.code && result.code != 200) {
            return handleApiErrors(result);
          } else {
            return result;
          }
        });
      })
      .catch(error => {
        logger.error(error);
        throw error;
      });
  } else {
    return handleApiErrors({ generalError: true });
  }
};

function* loadServiceResourceAvailability(payload) {
  //this function loads the customers list into redux
  try {
    const data = yield call(getServiceResourceAvailabilityApi, payload);
    if (!data || data.error) {
      yield put(data.error); // Yields effect to the reducer specifying the action type and user details
    } else {
      yield put({
        type: GOT_SERVICE_RESOURCE_AVAILABILITY_DATES,
        payload,
        data
      }); // Yields effect to the reducer specifying the action type and user details
    }
  } catch (error) {
    throw error;
  }
}
/***** SAGA END ******/

/***** SAGA START ******/

export let saveWaitlistApi = payload => {
  const { waitlistStepData, cb } = payload.data;
  return fetch(
    `${window.APP.apiPath}api/serviceprovider/${getSpId()}/waitlists`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: getLocalStorageItem("token_authorization")
      },
      method: "POST",
      body: JSON.stringify(waitlistStepData)
    }
  )
    .then(response => {
      return response.json().then(result => {
        if (result.code && result.code != 200) {
          return handleApiErrors(result);
        } else {
          if (cb) {
            setTimeout(() => {
              cb();
            }, 500);
          }
          return result;
        }
      });
    })
    .catch(error => {
      logger.error(error);
      throw error;
    });
};

function* saveWaitlist(payload) {
  try {
    const data = yield call(saveWaitlistApi, payload);
    if (!data || data.error) {
      yield put({ type: SAVE_WAITLIST_ERROR, message: data.error.data });
    } else {
      yield put({
        type: SAVED_WAITLIST
      });
    }
  } catch (error) {
    throw error;
  }
}
/***** SAGA END ******/

function* watchRequests() {
  yield* [
    takeEvery(
      GET_SERVICE_RESOURCE_AVAILABILITY_DATES,
      loadServiceResourceAvailability
    ),
    takeEvery(SAVE_WAITLIST, saveWaitlist)
  ];
}

export default [watchRequests];
